export const ItSendStatsActionTypes = {
  API_RESPONSE_SUCCESS: '@@infotools-send-stats/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@infotools-send-stats/API_RESPONSE_ERROR',

  GET_IT_SEND_STAT: '@@infotools-send-stats/GET_IT_SEND_STAT',
  LIST_IT_SEND_STATS: '@@infotools-send-stats/LIST_IT_SEND_STATS',
  IT_SEND_MAIL: '@@infotools-send-stats/IT_SEND_MAIL',
  ADD_IT_SEND_STAT: '@@infotools-send-stats/ADD_IT_SEND_STAT',
  UPDATE_IT_SEND_STAT: '@@infotools-send-stats/UPDATE_IT_SEND_STAT',
  DELETE_IT_SEND_STAT: '@@infotools-send-stats/DELETE_IT_SEND_STAT',

  RESET: '@@infotools-send-stats/RESET'
}
